define([
	'canvas/LoadingCanvas',
	'lib/jquery'
], function (
	LoadingCanvas,
	jQuery
) {
	'use strict';

	/**
	 * LoadingView class
	 */
	return function () {
		var _loadingCanvas = new LoadingCanvas(),
			_view;

		_view = (function () {
			var $view = jQuery('<div id="skIdS_loading-shadow"></div>');

			$view.append(_loadingCanvas.get());

			return $view;
		})();


		// public methods

		this.get = function () {
			return _view;
		};

		this.enableAnimation = function () {
			_loadingCanvas.enableAnimation();
		};

		this.disableAnimation = function () {
			_loadingCanvas.disableAnimation();
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/LoadingView.js
// module id = 372
// module chunks = 1